/**
 * 行政管理服务工具函数
 */

import axios from 'axios';

// 配置 axios 全局默认值
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

export const API_BASE = '/api';

// Helper to safely extract array from response
export const getListResponse = (data: any): any[] => {
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.results)) return data.results;
    return [];
};
